// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_errorMessage__EkQwY {
  font-weight: 600;
  font-size: 22px;
}

.styles_errorContainer__8ZyVM {
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/error-boundary-ui/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".errorMessage {\n  font-weight: 600;\n  font-size: 22px;\n}\n\n.errorContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  justify-content: center;\n  align-items: center;\n  //   min-height: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `styles_errorMessage__EkQwY`,
	"errorContainer": `styles_errorContainer__8ZyVM`
};
export default ___CSS_LOADER_EXPORT___;
